<button class=" btn btn-danger ml-1 mb-2" (click)="resetfn.emit()">  <span  class="fa fa-refresh mr-1" aria-hidden="true"></span>Reset</button>